<style lang="scss"
       module>
@import 'src/brand/brandColors.variables';
</style>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15.556 15.557">
    <path
      data-name="Union 3"
      d="M7.778 9.192l-6.364 6.365L0 14.142l6.364-6.364L0 1.414 1.414 0l6.364 6.364L14.142 0l1.415 1.414-6.365 6.364 6.364 6.364-1.415 1.415z"
      :fill="accent"/>
  </svg>
</template>

<script>
/* Vue Components */
/* Meteor packages */
/* NPM packages */
/* Methods */
/* Everything else */

export default {
  name: 'IconDelete',
  props: {
    accent: {
      type: String,
      default: '#eea417',
    },
  },
};
</script>
